import axios from 'axios';
export const updateTemplateAPI = (payload) => {
    let  apiUrl= `${process.env.REACT_APP_EQUIPMENT_BASE_URL}/api/bulkupload/updateinstrumentsbulkuploadtemplate`
      return axios.post(apiUrl,payload,{
            headers: {"Content-Type": "multipart/form-data",
            authorization: `Bearer ${localStorage.getItem('idToken')}`},
        }).then(resp=>resp)
}
